import { SERVICE_LOCATIONS_ENDPOINT } from "@config/endpoints";
import { IS_DEV } from "@config/consts";

import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";
import { ASYNC_ACTION_TYPES } from "@services/FetchFacade";
import { buildUrl } from "@services/BuildUrl";

import { asyncActionCreator } from "@app/services/AsyncActionCreator";
import { showGenericErrorToast } from "@app/containers/Toastify";

import {
  FetchCoverageProps,
  GetCoverageProps,
  CoverageResponse,
} from "./ServiceSelector.types";

const fetchCoverage = ({
  zipCode,
}: FetchCoverageProps): Promise<AsyncActionResult<CoverageResponse>> => {
  return asyncActionCreator({
    action: "",
    method: ASYNC_ACTION_TYPES.GET,
    url: buildUrl(SERVICE_LOCATIONS_ENDPOINT)
      .setQuery("zip", zipCode.trim(), { optional: false })
      .setQuery("serviceType", "", { optional: true })
      .done(),
  });
};

/**
 * @returns `true` if the zip code is covered by selected cleaning service, `false` otherwise.
 */
export const getCoverage = async ({
  zipCode,
  serviceType,
  showUncoveredModal,
}: GetCoverageProps): Promise<boolean> => {
  let isCoverage = false;

  if (!zipCode.trim()) return isCoverage;

  try {
    const { onSuccess, onError } = await fetchCoverage({
      zipCode,
    });

    onSuccess(({ data }) => {
      if (data.serviceTypes?.includes(serviceType)) {
        isCoverage = true;
      } else {
        showUncoveredModal(serviceType, zipCode);
      }
    });

    onError(errors => {
      showUncoveredModal(serviceType, zipCode);

      if (IS_DEV) {
        console.error(errors);
      }
    });
  } catch (error) {
    showGenericErrorToast();
  }

  return isCoverage;
};
